import { SetStateAction, useState } from "react";
import useBulkListingStats from "../../../data/useBulkListingStats";
import Modal from "../../../layouts/Modal";
import DashboardStat from "../../dashboard/DashboardStat";
import Card from "../../shared/Card/Card";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";


export default function RecentlyListedStats() {
  const { stats } = useBulkListingStats();

  const [errorsOpen, setErrorsOpen] = useState(false);

  if (stats.isLoading) return null;

  const data = stats.data?.data;

  if (!data) return null;

  return (
    <>
      <Modal open={errorsOpen} setOpen={setErrorsOpen} width={"max-w-6xl"}>
        <div className="my-4">
          <h1 className="text-2xl font-semibold mb-4 pb-2 border-b">Top Recently Listed Errors</h1>

          {data.errorCount && Object.keys(data.errorCount).length > 0 ? (
            <div className="space-y-3 max-h-[40vh] overflow-y-auto pr-2">
              {Object.entries(data.errorCount).map(([rawKey, count]) => {
                let displayMessage = rawKey;

                // Try to extract message if key contains JSON
                if (rawKey.trim().startsWith("{")) {
                  try {
                    const parsed = JSON.parse(rawKey);

                    displayMessage =
                      parsed?.errors?.[0]?.message ||
                      parsed?.responses?.[0]?.errors?.[0]?.message ||
                      rawKey;
                  } catch {
                    // skip JSON parse failure; fallback to raw string
                  }
                }

                return (
                  <div
                    key={rawKey}
                    className="border rounded-lg p-3 bg-gray-50 shadow-sm hover:bg-gray-100 transition"
                  >
                    <div className="flex items-start gap-3">
                      {/* Badge */}
                      <span className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-md shrink-0">
                        {count}×
                      </span>

                      {/* Message */}
                      <p className="text-gray-800 break-words leading-snug whitespace-pre-wrap">
                        {displayMessage}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="text-gray-500">No errors found.</p>
          )}
        </div>

      </Modal>
      <Card bodyClassName="p-4 grid grid-cols-1 lg:grid-cols-5 gap-4" title="Recently Listed Stats" collapsible >
        <DashboardStat title={data?.all?.toString()} desc={"All"} color={"yellow"} />
        <DashboardStat title={data?.manual?.toString()} desc={"Manual"} color={"green"} />
        <DashboardStat title={data?.automated?.toString()} desc={"Automated"} color={"blue"} />
        <DashboardStat title={data?.relisted?.toString()} desc={"Relisted"} color={"purple"} />
        <DashboardStat title={data?.failed?.toString()} desc={"Failed"} color={"red"} onClick={() => setErrorsOpen(true)} Icon={ArrowTopRightOnSquareIcon} />
      </Card>
    </>
  )

}